/**
 * School-wide demo totals for Basisschool De Linde.
 * Counts describe the whole school. They are not joined to a person, and groups
 * smaller than `minimumGroupSize` are left out so one user cannot be singled out.
 */
export const minimumGroupSize = 5;

const platformUsage = {
  users: 12,
  questionsThisMonth: 84,
  conversationsThisMonth: 84,
  activeUsersLast30Days: 10,
  returningUsers: 9,
};

const courseAdoption = {
  clicked: 9,
  started: 6,
  completed: 5,
};

export type CourseFunnelStep = "clicked" | "started" | "completed";

export type CourseFunnelEntry = {
  step: CourseFunnelStep;
  users: number | null;
};

export function reportedUserCount(count: number): number | null {
  return count >= minimumGroupSize ? count : null;
}

export function averageConversationsPerUser(): number {
  return platformUsage.conversationsThisMonth / platformUsage.users;
}

export function activeUserPercentage(): number {
  return Math.round((platformUsage.activeUsersLast30Days / platformUsage.users) * 100);
}

/** Whole-school count behind a trend percentage. Small groups stay hidden. */
export function activeUsersAt(share: number): number | null {
  return reportedUserCount(Math.round((share / 100) * platformUsage.users));
}

export function returningUserPercentage(): number {
  return Math.round((platformUsage.returningUsers / platformUsage.users) * 100);
}

export function courseFunnel(): CourseFunnelEntry[] {
  return [
    { step: "clicked", users: reportedUserCount(courseAdoption.clicked) },
    { step: "started", users: reportedUserCount(courseAdoption.started) },
    { step: "completed", users: reportedUserCount(courseAdoption.completed) },
  ];
}

export function questionsThisMonth(): number {
  return platformUsage.questionsThisMonth;
}
